import intl from 'react-intl-universal';
import { isArray } from 'lodash';
import { ProColumnType } from '@ant-design/pro-components';
import { message } from 'antd';
import { FormItemValueType } from '@/components/index';
import type { DiyFieldItem } from '@/type/dynamicTable';

export const getDataIndex = (
    dataIndex?: string | number | (string | number)[],
) => {
    return isArray(dataIndex) ? dataIndex.join('.') : dataIndex || '';
};

const transitionTableItem = (item) => {
    return {
        ...item,
        key: `table_${getDataIndex(item.dataIndex)}`,
        hideInSearch: true,
    };
};
const transitionFilterItem = (item) => {
    return {
        ...item,
        hideInTable: true,
    };
};

const getAllTableColumns = (
    originColumns: ProColumnType<any, FormItemValueType>[],
) => {
    return originColumns?.map(transitionTableItem) || [];
};
export const getAllFilterColumns = (
    originColumns: ProColumnType<any, FormItemValueType>[] = [],
) => {
    return (
        originColumns
            ?.filter((col) => !col.hideInSearch)
            .map(transitionFilterItem) || []
    );
};

export const clearFilterColumns = (
    originColumns: ProColumnType<any, FormItemValueType>[] = [],
    showField: DiyFieldItem[],
) => {
    if (!showField?.length) {
        return getAllFilterColumns(originColumns);
    }

    const columns: ProColumnType<any, FormItemValueType>[] = [];
    originColumns?.forEach((field) => {
        // if (field.status) {
        const target = showField?.find((item) => {
            return getDataIndex(field.dataIndex) === item.field;
        });
        if (!target || target.status) {
            columns.push(transitionFilterItem(field));
        }
        // }
    });

    if (!columns.length) {
        message.warning(
            intl.get(
                '暂未匹配到合适的自定义筛选字段，已展示全部筛选字段，可以重新设置',
            ),
        );
        return getAllFilterColumns(originColumns);
    }

    return columns;
};

export const clearColumns = (
    originColumns: ProColumnType<any, FormItemValueType>[] = [],
    showField: DiyFieldItem[],
) => {
    if (!showField?.length) {
        return getAllTableColumns(originColumns);
    }
    const columns: ProColumnType<any, FormItemValueType>[] = [];
    originColumns?.forEach((item) => {
        const target = showField?.find((field) => {
            return getDataIndex(item.dataIndex) === field.field;
        });
        if (target?.status) {
            // if (target) {
            columns.push(transitionTableItem(item));
            // }
        } else if (!target) {
            columns.push(transitionTableItem(item));
        }
    });

    if (!columns.length) {
        message.warning(
            intl.get('暂未匹配到合适的表格字段，已展示全部，请重新设置'),
        );
        return getAllTableColumns(originColumns);
    }

    return columns;
};
